import { render, staticRenderFns } from "./Solid.vue?vue&type=template&id=3ed53746&scoped=true&"
import script from "./Solid.vue?vue&type=script&lang=ts&"
export * from "./Solid.vue?vue&type=script&lang=ts&"
import style0 from "./Solid.vue?vue&type=style&index=0&id=3ed53746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed53746",
  null
  
)

export default component.exports